export default __webpack_public_path__ + "static/media/alert_error.49b22cf0.svg";